import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Metronic modal container
 */
export default function Modal({ id, tabIndex, onClose, children, escToClose }) {
  useEffect(() => {
    const modalEl = $(`#${id}`);
    const options = { backdrop: 'static' };
    if (!escToClose) {
      options.keyboard = false;
    }
    modalEl.modal(options);
    if (onClose) {
      modalEl.on('hidden.bs.modal', () => onClose(null));
    }

    return () => modalEl.modal('hide');
  }, []);

  return (
    <div className="modal fade" id={id} tabIndex={tabIndex} role="dialog">
      {children}
    </div>
  );
}

Modal.propTypes = {
  /** modal container html id */
  id: PropTypes.string,
  /** React components to render inside the modal */
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func,
  tabIndex: PropTypes.number,
  escToClose: PropTypes.bool,
};

Modal.defaultProps = {
  id: 'modalContainer',
  tabIndex: -1,
  onClose: null,
  escToClose: true,
};
